import { getFiltersAndFields, getMainFilterList } from '@/api/filter'
export const DynamicFilter = {
  data () {
    return {
      fieldtabledata: [],
      filterconditiondata: [],

      filterdata: [],
      user_main_filter: [
        {
          id:null,
          filter_name:'All'
        }
      ]
    }
  },
  methods: {
    async fetchMainFilter (model, tableName) {
      try {
        const customer_id = this.$store.getters.customerId
        const { data } = await getMainFilterList(model, customer_id, tableName)

        const userFilterData = data.data.filters //getting all filter main value
        this.user_main_filter = [...this.user_main_filter, ...userFilterData]//merging static
      } catch (err) {}
      // this.user_main_filter = data.data.filters
    },
    async fetchFieldAndFilterList (model, tableName) {
      try {
        const { data } = await getFiltersAndFields(model, tableName, this.$store.getters.customerId)

        //

        this.filterconditiondata = data.data.filters //this is storing all filter

        this.fieldtabledata = data.data.fields //this is storing all the static fields

        //

        let arrDynamicField = []
        //
        if (this.custom_fields.length) {
          arrDynamicField = this.custom_fields.map(function (element) {
            return {
              field_label: element.label,
              // field_name: element.label,
              id: element.attribute_id,
              platform_field_types_id: element.type,
              table_type: 'dynamic',
              input_type: element.inputtype,
              multivalue: element.multivalue
            }
          })
        }

        this.fieldtabledata = [...this.fieldtabledata, ...arrDynamicField] //merging static with dynamic table field

        //

        //
      } catch (err) {
        //
      }
    },
    filterSidebarEvent (obj) {
      if (obj === false) {
        this.filterSidebarBoolean = false
      } else {
        this.user_main_filter.unshift(obj)
        this.filterSidebarBoolean = false


      }
    }
  }
}
